import { render } from "./Incentive.view.vue?vue&type=template&id=1a4b5174"
import script from "./Incentive.view.vue?vue&type=script&lang=js"
export * from "./Incentive.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__